/**
 * Cabinet Theme — Mantine theme для ЛК родителя.
 *
 * Палитра, шрифты и радиусы взяты из homepage-eto-interesno v2.html
 * для визуальной унификации с целевым сайтом компании.
 */
import { createTheme } from '@mantine/core';
import { colors, typography, radius } from './designTokens';

export const cabinetTheme = createTheme({
  primaryColor: 'brand-purple',
  primaryShade: 6,

  colors: {
    'brand-purple': colors.purpleShades,
    'brand-orange': colors.orangeShades,
  },

  fontFamily: typography.fontFamily,
  fontFamilyMonospace: 'Menlo, Monaco, Consolas, monospace',

  headings: {
    fontFamily: typography.fontFamilyHeading,
    fontWeight: '900',
    sizes: {
      h1: { fontSize: '40px', lineHeight: '1.15', fontWeight: '1000' },
      h2: { fontSize: '32px', lineHeight: '1.2', fontWeight: '900' },
      h3: { fontSize: '24px', lineHeight: '1.25', fontWeight: '900' },
      h4: { fontSize: '20px', lineHeight: '1.3', fontWeight: '900' },
    },
  },

  fontSizes: {
    xs: '11px',
    sm: '13px',
    md: '14px',
    lg: '16px',
    xl: '20px',
  },

  defaultRadius: 'lg',
  radius: {
    xs: '6px',
    sm: '10px',
    md: '14px',
    lg: '20px',
    xl: '28px',
  },

  // Дефолтные пропсы и стили компонентов
  components: {
    Button: {
      defaultProps: {
        radius: 100,        // pill-shape
        fw: 900,
      },
      styles: {
        root: {
          fontFamily: typography.fontFamilyHeading,
          letterSpacing: 0,
        },
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    PasswordInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    NumberInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Paper: {
      defaultProps: {
        radius: 'lg',
      },
    },
    Card: {
      defaultProps: {
        radius: 'lg',
      },
    },
    Badge: {
      defaultProps: {
        radius: 'xl',
        fw: 800,
      },
    },
    Notification: {
      defaultProps: {
        radius: 'md',
      },
    },
  },

  other: {
    // Дополнительные кастомные значения, доступные через theme.other
    pageBackground: colors.bg.page,
    textPrimary: colors.text.primary,
    textMuted: colors.text.muted,
    purple: colors.brand.purple,
    orange: colors.brand.orange,
    yellow: colors.brand.yellow,
  },
});
